import { render, staticRenderFns } from "./SendDocumentEdit.vue?vue&type=template&id=362b704a&scoped=true&lang=pug"
import script from "./SendDocumentEdit.vue?vue&type=script&lang=ts"
export * from "./SendDocumentEdit.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentEdit.vue?vue&type=style&index=0&id=362b704a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362b704a",
  null
  
)

export default component.exports